import { render, staticRenderFns } from "./Historic.vue?vue&type=template&id=44badbcf"
import script from "./Historic.vue?vue&type=script&lang=js"
export * from "./Historic.vue?vue&type=script&lang=js"
import style0 from "./Historic.vue?vue&type=style&index=0&id=44badbcf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports